import { useState, useEffect, useCallback } from "react"
import { useDispatch, useSelector } from "react-redux"
import { Row, Col } from "antd"
import { guideSelector, updateGuide } from "store/user"
import { serialize } from "object-to-formdata"
import { DocumentUploadGrid } from "ui/DocumentUploadGrid"
import { mapLicenses, serializeLicensesData } from "helpers/files"
import { ContentActionButtons } from "layoutsV2/pro/PersonalInfoLayout/ContentActionButtons"
import { useSaveContext } from "layoutsV2/pro/PersonalInfoLayout/SaveContext"
import { receiveErrors } from "modules/errors/reducer"

export const PersonalInfoLicenses = () => {
  const [dirty, setDirty] = useState(false)
  const guide = useSelector(guideSelector)
  const dispatch = useDispatch()
  const { registerSaveCallback, unregisterSaveCallback } = useSaveContext()
  const licenses = mapLicenses(guide.documents)

  const [filesState, setFilesState] = useState({
    ...licenses
  })

  const handleFileListChange = (name, newFileList) => {
    setFilesState((prevState) => ({
      ...prevState,
      [name]: newFileList
    }))
    setDirty(true)
    dispatch(
      receiveErrors({
        data: { message: { documents: [] } },
        showToast: false
      })
    )
  }

  // Accepts (values, callback) or (callback) for compatibility
  const handleSubmit = (valuesOrCallback, maybeCallback) => {
    let callback = maybeCallback || valuesOrCallback
    if (typeof callback !== "function") {
      callback = () => {}
    }
    if (dirty) {
      const formData = serialize({ guide: serializeLicensesData(filesState) }, { indices: true })
      dispatch(updateGuide(guide.id, formData))
        .then(() => {
          setDirty(false)
          callback()
        })
        .catch((error) => {
         console.log(error,'error')
        })
    } else {
      callback()
    }
  }

  // Create save callback for sidebar navigation
  const saveFormCallback = useCallback(
    (onComplete) => {
      handleSubmit(onComplete)
    },
    [handleSubmit]
  )

  // Register save callback on mount, unregister on unmount
  useEffect(() => {
    registerSaveCallback(saveFormCallback)
    return () => {
      unregisterSaveCallback()
    }
  }, [registerSaveCallback, unregisterSaveCallback, saveFormCallback])

  return (
    <Row>
      <Col sm={24} md={20}>
        <DocumentUploadGrid handleFileListChange={handleFileListChange} filesState={filesState} />
      </Col>
      <Col lg={16} md={24} xs={24} span={16}>
        <ContentActionButtons onFinish={handleSubmit} />
      </Col>
    </Row>
  )
}
